
export const inscribe = (formation: string): void => {
  const msg = `Bonjour OVA Consulting,

Je souhaite m'inscrire à la formation suivante :

${formation}

Merci de me contacter pour confirmer ma participation et les modalités.`;

  // On utilise les "Template Literals" (backticks ``) pour plus de lisibilité
  const whatsappUrl = `https://wa.me/237696427703?text=${encodeURIComponent(msg)}`;
  
  window.open(whatsappUrl, '_blank');
};